module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberschleissheim/01-7b90f883da4ee4788cff2eb6db1e6a3e.jpg";